import React from 'react';

const StepUpdate = ({ nextStep, handleClose }) => (
  <div className="onboarding-content center">
    <div>
      <h2 className="onboarding-heading large">Update Your Profile and Preferences</h2>
      <p className="mt2 mb3">
        We have added a lot of powerful tools to The Information. Updating your interests and
        profile information will help us deliver the best experience for you.
      </p>
      <button onClick={nextStep} className="button button-red button-stretch button-small">
        Get Started
      </button>
      <button onClick={handleClose} className="onboarding-not-now-button">
        Not Now
      </button>
    </div>
  </div>
);

export default StepUpdate;
